import { Button, Input } from "@softmax/design-system";
import { spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

type RevisionRejectionFormProps = Readonly<{
  version: number;
  reason: string;
  canChangeRevision: boolean;
  onReasonChange(reason: string): void;
  onReject(): void;
}>;

export function RevisionRejectionForm({
  version,
  reason,
  canChangeRevision,
  onReasonChange,
  onReject,
}: RevisionRejectionFormProps) {
  return (
    <div {...stylex.props(styles.rejection)}>
      <Input
        aria-label={`Reason for rejecting revision ${version}`}
        value={reason}
        onChange={(event) => onReasonChange(event.target.value)}
        placeholder="Rejection reason (1-500 characters)"
        maxLength={500}
        disabled={!canChangeRevision}
      />
      <Button
        size="sm"
        variant="danger"
        disabled={
          !canChangeRevision ||
          reason.trim().length < 1 ||
          reason.trim().length > 500
        }
        onClick={onReject}
      >
        Confirm reject
      </Button>
    </div>
  );
}

const styles = stylex.create({
  rejection: { display: "grid", justifyItems: "start", gap: spacing.space8 },
});
